/**
 * Created by Viktor on 2016.03.21..
 */
$(function(){
    valuation.init();
    if($('#valuationSuccess').length){
        bootbox.alert($('#valuationSuccess').html());
    }
});

var valuation = {
    freePlace: [4,3,2,1],
    init: function(){
        $(document).on('change', '#multiImage', this.readUrl);
        $(document).on('click','.MultiFile-remove', this.removeFile);
        $('form[name=valuation]').submit(this.validate);
        $('.images a:not(.MultiFile-remove)').click(this.imgClick);
    },
    readUrl: function(){
        let input = this;
        if(valuation.freePlace.length > 0) {
            var index = valuation.freePlace.pop();

            if (input.files && input.files[0]) {
                var reader = new FileReader();

                reader.onload = function (e) {
                    $('#p_' + index).attr('src', e.target.result);
                    $('#a_' + index).attr('href', e.target.result);
                };

                reader.readAsDataURL(input.files[0]);
            }
            var clone = $(this).clone();
			clone.insertAfter($(this));
            $(this).insertAfter($('#p_' + index));
			$(this).hide();
            $(this).attr('name', 'img[]');
            $(this).attr('id','i_'+index);
            $('[data-id='+index+']').addClass('d-block').removeClass('d-none');
        }
        else{
            alert('Maximum 4 képet tölthet fel');
        }
    },

    removeFile:function(){
        let id = $(this).data('id');
        $('#i_'+id).remove();
        $(this).addClass('d-none').removeClass('d-block');
        let defimg = $('#p_'+id).data('default');
        $('#p_'+id).attr('src',defimg);
        $('#a_'+id).attr('href',defimg);
        valuation.freePlace.push(id);
        valuation.freePlace.sort();
        valuation.freePlace.reverse();
    },

    validate:function(e){
        var submit = true;
        if($('input[name=name]').val() == ''){
            $('input[name=name]').addClass('is-invalid');
            submit = false;
        }
        else{
            $('input[name=name]').removeClass('is-invalid');
        }

        if($('input[name=email]').val() == '' || !valuation.validateEmail($('input[name=email]').val())){
            $('input[name=email]').addClass('is-invalid');
            submit = false;
        }
        else{
            $('input[name=email]').removeClass('is-invalid');
        }

        if($('input[type=file]').length < 2){
            $('#multiImage').closest('.row').addClass('border-danger').addClass('border');
            submit = false;
        }
        else{
            $('#multiImage').closest('.row').removeClass('border-danger').removeClass('border');
        }

        if(!$('input[name=cc2]').is(':checked')){
            $('input[name=cc2]').addClass('is-invalid');
        }
        else{
            $('input[name=cc2]').removeClass('is-invalid');
        }

        if(!submit){
            e.preventDefault();
        }
    },

    validateEmail: function(email){
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },

    imgClick: function(e){
        var src = $(this).find('img').attr('src');
        var orig = $(this).find('img').data('default');
        if(src == orig){
            e.stopPropagation();
            e.preventDefault();
            $('#multiImage').click();
        }
    }
};